import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/auth/RequireAuth';
import { RequirePermission } from '@/auth/RequirePermission';
import { AppLayout } from '@/layout/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { AdminUsersPage } from '@/pages/admin-users/AdminUsersPage';
import { AuditPage } from '@/pages/audit/AuditPage';
import { MaintenancePage } from '@/pages/maintenance/MaintenancePage';
import { ChangePasswordPage } from '@/pages/ChangePasswordPage';
import { DirectOrgsPage } from '@/pages/orgs/DirectOrgsPage';
import { OrgDetailPage } from '@/pages/orgs/OrgDetailPage';
import { OrgsListPage } from '@/pages/orgs/OrgsListPage';
import { UsagePage } from '@/pages/usage/UsagePage';
import { PartnerDetailPage } from '@/pages/partners/PartnerDetailPage';
import { PartnersListPage } from '@/pages/partners/PartnersListPage';
import { PlansPage } from '@/pages/plans/PlansPage';

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      {
        path: '/',
        element: (
          <RequirePermission permission="dashboard.view">
            <DashboardPage />
          </RequirePermission>
        ),
      },
      {
        path: '/partners',
        element: (
          <RequirePermission permission="partners.view">
            <PartnersListPage />
          </RequirePermission>
        ),
      },
      {
        path: '/partners/:partnerId',
        element: (
          <RequirePermission permission="partners.view">
            <PartnerDetailPage />
          </RequirePermission>
        ),
      },
      {
        path: '/plans',
        element: (
          <RequirePermission permission="plans.view">
            <PlansPage />
          </RequirePermission>
        ),
      },
      {
        path: '/orgs',
        element: (
          <RequirePermission permission="orgs.view">
            <OrgsListPage />
          </RequirePermission>
        ),
      },
      {
        path: '/orgs/:orgId',
        element: (
          <RequirePermission permission="orgs.view">
            <OrgDetailPage />
          </RequirePermission>
        ),
      },
      {
        path: '/direct-orgs',
        element: (
          <RequirePermission permission="orgs.view">
            <DirectOrgsPage />
          </RequirePermission>
        ),
      },
      {
        path: '/usage',
        element: (
          <RequirePermission permission="usage.export">
            <UsagePage />
          </RequirePermission>
        ),
      },
      {
        path: '/account/password',
        element: (
          <RequirePermission permission="account.changePassword">
            <ChangePasswordPage />
          </RequirePermission>
        ),
      },
      {
        path: '/maintenance',
        element: (
          <RequirePermission permission="maintenance.view">
            <MaintenancePage />
          </RequirePermission>
        ),
      },
      {
        path: '/audit',
        element: (
          <RequirePermission permission="audit.view">
            <AuditPage />
          </RequirePermission>
        ),
      },
      {
        path: '/admin-users',
        element: (
          <RequirePermission permission="adminUsers.manage">
            <AdminUsersPage />
          </RequirePermission>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
